// Zoom-scaled polygon styling. Zoomed out, thousands of borders dominate
// the fill colors and read as noise, so border weight ramps linearly from
// full at zoom >= 13 down to nothing at zoom <= 9 — while fill opacity and
// a dot stroke ramp the opposite way, so at overview levels the polygons
// the opposite way, so at overview levels the polygons read as solid color
// density instead of vanishing with their borders.
export const BORDER_FULL_ZOOM = 13;
export const BORDER_ZERO_ZOOM = 9;

export function borderWeightForZoom(zoom, full) {
  const t = (zoom - BORDER_ZERO_ZOOM) / (BORDER_FULL_ZOOM - BORDER_ZERO_ZOOM);
  return full * Math.min(1, Math.max(0, t));
}

// Dash patterns only survive at detail zooms: a 4/3 dash on a sub-1px line
// over a small polygon reads as smudge, not as a dashed border. Below the
// full-weight zoom the border renders solid.
export function dashForZoom(zoom, dash) {
  return zoom >= BORDER_FULL_ZOOM ? dash : null;
}

// Inverse ramp for fills: at detail zooms the translucent base opacity lets
// the basemap show through; as borders thin away the fill strengthens toward
// `strong` so vineyard density stays visible. Completes higher than the
// border ramp (zoom 10, not 9) so the mid band doesn't go sparse.
export const FILL_STRONG_ZOOM = 10;

export function fillOpacityForZoom(zoom, base, strong) {
  const t = Math.min(1, Math.max(0, (zoom - FILL_STRONG_ZOOM) / (BORDER_FULL_ZOOM - FILL_STRONG_ZOOM)));
  return base * t + strong * (1 - t);
}

// Minimum-size symbolization: below the border ramp polygons shrink toward
// sub-pixel size and pure fills vanish no matter how opaque, so regions read
// as empty. A hairline fill-colored stroke fattens back in from zoom 12 to 9.5,
// rendering each small polygon as a visible color dot of vineyard density.
export const DOT_START_ZOOM = 12;
export const DOT_FULL_ZOOM = 9.5;
export const DOT_WEIGHT = 0.5;

export function dotWeightForZoom(zoom) {
  const t = (DOT_START_ZOOM - zoom) / (DOT_START_ZOOM - DOT_FULL_ZOOM);
  return DOT_WEIGHT * Math.min(1, Math.max(0, t));
}

// Heliport tour markers appear at zoom 12. At that first appearance they
// hold back — smaller and translucent — and ramp linearly to full size and
// opacity by zoom 14, so the launcher reads as a subtle invitation at mid
// zooms instead of dominating the region view.
export const HELI_APPEAR_ZOOM = 12;
export const HELI_FULL_ZOOM = 14;
export const HELI_FULL_SIZE = 34;
export const HELI_MIN_SIZE = 24;
export const HELI_MIN_OPACITY = 0.55;

export function heliStyleForZoom(zoom) {
  const t = Math.min(1, Math.max(0, (zoom - HELI_APPEAR_ZOOM) / (HELI_FULL_ZOOM - HELI_APPEAR_ZOOM)));
  return {
    size: Math.round(HELI_MIN_SIZE + (HELI_FULL_SIZE - HELI_MIN_SIZE) * t),
    opacity: HELI_MIN_OPACITY + (1 - HELI_MIN_OPACITY) * t,
  };
}
